module.exports = __webpack_public_path__ + "2d93ec1f417429087d25534e8a4f29aa.svg";